import React,{useState} from 'react';
import { IOpcion } from '../../../interfaces/OpcionReembolso';

interface dataDisponible {
    monto: number,
    cupon: string,
    acumulado: number,
    fecha: Date
}

interface IProps {
    opcion: IOpcion[],
    modo: number,
    dias?: number,
    nuevaFechaPago?: Date
}

interface IState {
    loading: boolean,
}

const Confirmar = (props: IProps) => {
    const formatMoney = (amount: any) => {
        var decimalCount = 2;
        var decimal = ",";
        var thousands = ".";

        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i: any = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j: any = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    }
    let hoy: Date = new Date();
    let date: Date = (props.nuevaFechaPago ? props.nuevaFechaPago : new Date());
    let dateText = (String(date.getDate()).padStart(2, '0') + "/" + (String(date.getMonth() + 1)).padStart(2, '0') + "/" + date.getFullYear());

    return (
        <div>
            <div className="card">
                <div className="row">
                    <div className="col-6">
                        <label>Pagos utilizados:</label>
                    </div>
                    <div className="col-6 text-right">
                        <span>$</span>
                        <label>{formatMoney(props.opcion[props.modo].adelanto)}</label>
                    </div>
                    <div className="col-6">
                        <label>Pagos remanentes:</label>
                    </div>
                    <div className="col-6 text-right">
                        <span>$</span>
                        <label>{formatMoney(props.opcion[props.modo].adelantoMaximo - props.opcion[props.modo].adelanto)}</label>
                    </div>
                    <div className="col-6">
                        <label>Costo total:</label>
                    </div>
                    <div className="col-6 text-right">
                        <label>(<span>$</span>{formatMoney(props.opcion[props.modo].costoAdelanto)})</label>
                    </div>
                    <div className="col-6">
                        <label>Plazo:</label>
                    </div>
                    <div className="col-6 text-right">
                        <label>{props.opcion[props.modo].plazoTexto}</label>
                    </div>
                    <div className="col-6">
                        <label>Fecha de Acreditación:</label>
                    </div>
                    <div className="col-6 text-right">
                        <label>{dateText}</label>

                    </div>
                    <div className="col-6">
                        <label>Medio:</label>
                    </div>
                    <div className="col-6 text-right">
                        <label>{props.modo == 1 ? 'Transferencia' : 'Empresarial'}</label>
                    </div>
                </div>
            </div>
            <div className="card mt-2">
                <div className="row">
                    <div className="col-6">
                        <label>Dias ganados:</label>
                    </div>
                    <div className="col-6 text-right">
                        <label>{props.dias} dias</label>
                    </div>
                    <div className="col-6">
                        <label>Monto a acreditar:</label>
                    </div>
                    <div className="col-6 text-right">
                        <span>$</span>
                        <label>{formatMoney(props.opcion[props.modo].montoAcreditar)}</label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Confirmar
